export default "<div id=\"target\">&nbsp;</div>\n<router-outlet></router-outlet>\n"